import { render } from "./Menu_profile.vue?vue&type=template&id=72913f44&scoped=true"
import script from "./Menu_profile.vue?vue&type=script&lang=js"
export * from "./Menu_profile.vue?vue&type=script&lang=js"

import "./Menu_profile.vue?vue&type=style&index=0&id=72913f44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72913f44"]])

export default __exports__